/**
 * Mapping of country name to country id
 */
export const COUNTRY_ID = {
  UNITED_STATES: 1,
};
